module.exports = __webpack_public_path__ + "img/es.596f16b6.png";